export const UI_SELLERS_DRAWER_OPEN = '@UI_SELLERS_DRAWER_OPEN'
export const UI_SELLERS_DRAWER_CLOSE = '@UI_SELLERS_DRAWER_CLOSE'

export const UI_SELLERS_DRAWER_TOGGLE = '@UI_SELLERS_DRAWER_TOGGLE'

export const UI_STOCKINFO_DRAWER_OPEN = '@UI_STOCKINFO_DRAWER_OPEN'
export const UI_STOCKINFO_DRAWER_CLOSE = '@UI_STOCKINFO_DRAWER_CLOSE'

export default {
  UI_SELLERS_DRAWER_OPEN,
  UI_SELLERS_DRAWER_CLOSE,
  UI_SELLERS_DRAWER_TOGGLE,
  UI_STOCKINFO_DRAWER_OPEN,
  UI_STOCKINFO_DRAWER_CLOSE
}
